import {MoodQuestion} from './moodQuestion';

export class Rating {
  public id: number;
  public rating: number;
  public question: MoodQuestion;

  constructor(id: number, rating: number, question: MoodQuestion) {
    this.id = id;
    this.rating = rating;
    this.question = question;
  }
}
